var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "engine-run-message-cards-wrapper",
    },
    _vm._l(_vm.summaryMessageLogCards, function (messageLog) {
      return _c("donut-card", {
        key: `messageLog_${messageLog.id}`,
        attrs: {
          promise: _vm.promise,
          title: messageLog.title,
          color: messageLog.color,
          count: messageLog.count,
          total: _vm.totalCount,
          hoverable: _vm.isCardHoverable,
          selected: _vm.selectedMessage === messageLog.id,
          wide: "",
        },
        nativeOn: {
          click: function ($event) {
            return _vm.selectMessageLog(messageLog.id)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }